import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { Box } from "@mui/material";

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
  isUseText: PropTypes.bool,
};

export default function Logo({
  disabledLink = false,
  isUseText = false,
  isUseYellow = false,
  sx,
}) {
  const logo = (
    <Box
      component="img"
      src={
        (isUseYellow && "/logo/logo-yellow.png") ||
        (isUseText ? "/logo/logo-text.png" : "/logo/logo.png")
      }
      sx={{ width: "auto", height: 40, ...sx }}
    />
  );

  if (disabledLink) {
    // eslint-disable-next-line
    return <>{logo}</>;
  }

  return <RouterLink to="https://cribsfinder.com">{logo}</RouterLink>;
}
